/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Metadata_Scan_TitleInputs */

const en_player_metadata_scan_title = /** @type {(inputs: Player_Metadata_Scan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata Scan`)
};

const fr_player_metadata_scan_title = /** @type {(inputs: Player_Metadata_Scan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse des Metadonnees`)
};

const de_player_metadata_scan_title = /** @type {(inputs: Player_Metadata_Scan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadaten-Scan`)
};

const it_player_metadata_scan_title = /** @type {(inputs: Player_Metadata_Scan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scansione dei metadati`)
};

const ru_player_metadata_scan_title = /** @type {(inputs: Player_Metadata_Scan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сканирование метаданных`)
};

const es_player_metadata_scan_title = /** @type {(inputs: Player_Metadata_Scan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escaneo de metadatos`)
};

const zh_cn2_player_metadata_scan_title = /** @type {(inputs: Player_Metadata_Scan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元数据扫描`)
};

const ja_player_metadata_scan_title = /** @type {(inputs: Player_Metadata_Scan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メタデータスキャン`)
};

const hi_player_metadata_scan_title = /** @type {(inputs: Player_Metadata_Scan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेटाडेटा स्कैन`)
};

const pt_pt2_player_metadata_scan_title = /** @type {(inputs: Player_Metadata_Scan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análise de Metadados`)
};

/**
* | output |
* | --- |
* | "Metadata Scan" |
*
* @param {Player_Metadata_Scan_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_metadata_scan_title = /** @type {((inputs?: Player_Metadata_Scan_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Metadata_Scan_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_player_metadata_scan_title(inputs)
	if (locale === "de") return de_player_metadata_scan_title(inputs)
	if (locale === "it") return it_player_metadata_scan_title(inputs)
	if (locale === "ru") return ru_player_metadata_scan_title(inputs)
	if (locale === "es") return es_player_metadata_scan_title(inputs)
	if (locale === "zh-CN") return zh_cn2_player_metadata_scan_title(inputs)
	if (locale === "ja") return ja_player_metadata_scan_title(inputs)
	if (locale === "hi") return hi_player_metadata_scan_title(inputs)
	if (locale === "pt-PT") return pt_pt2_player_metadata_scan_title(inputs)
	return en_player_metadata_scan_title(inputs)
});